/* eslint-disable react/forbid-prop-types */
/* eslint-disable one-var */
/* eslint-disable prefer-destructuring */
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { MdAirportShuttle } from 'react-icons/md';
import './BusBookingDetails.scss';
import {
  formatDate,
  formatTimeString,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import { DATE_MONTH_YEAR_VIEW_FORMAT } from '../../../shared/constants/Constants';

function BookingDetails({ bookingDetails }) {
  const getBusAddress = (addressString) => {
    const addressArray = String(addressString).split('##');
    if (addressArray.length === 1 && addressArray[0] === '') return '';
    let phoneNumber = '',
      busStop = '',
      place = '',
      busNumber = '',
      address = '';
    if (addressArray.length > 0) busNumber = addressArray[0];
    if (addressArray.length > 2) phoneNumber = addressArray[2];
    if (addressArray.length > 4) busStop = addressArray[4];
    if (addressArray.length > 5) place = addressArray[5];

    if (busStop) address += `${busStop}, `;
    if (place) address += `${place}, `;
    if (phoneNumber) address += `PH No: ${phoneNumber}, `;
    if (busNumber) address += `Bus Number: ${busNumber}.`;

    return address;
  };
  return (
    <section className="view-booking-details-page">
      <div className="view-booking-details-page__bus-details">
        <div className="view-booking-details-page__bus-details_check-in">
          <div
            style={{
              flex: 2,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <span className="view-booking-details-page__bus-details_check-in_title">
              {bookingDetails.BoardingPointName}
            </span>
            <span className="view-booking-details-page__bus-details_check-in_date">
              {`${
                bookingDetails.DateOfJourney
                  ? formatDate(
                      getNewDate(bookingDetails.DateOfJourney),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )
                  : ''
              } ${
                bookingDetails.DepTime
                  ? formatTimeString(bookingDetails.DepTime)
                  : ''
              }`}
            </span>
          </div>
          <div
            style={{ flex: 3 }}
            className="d-flex flex-column text-center position-relative"
          >
            <div className="view-booking-details-page__bus-details_check-in_container">
              <hr className="view-booking-details-page__bus-details_check-in_container_hr" />
              <MdAirportShuttle className="view-booking-details-page__bus-details_check-in_container_icon" />
              <hr className="view-booking-details-page__bus-details_check-in_container_hr" />
            </div>
          </div>
          <div
            style={{
              flex: 2,
              textAlign: 'right',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <span className="view-booking-details-page__bus-details_check-in_title">
              {bookingDetails.DroppingPointName}
            </span>
            <span className="view-booking-details-page__bus-details_check-in_date">
              {`${
                bookingDetails.DateOfArrival
                  ? formatDate(
                      getNewDate(bookingDetails.DateOfArrival),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )
                  : 'N/A'
              } ${
                bookingDetails.ArrTime
                  ? formatTimeString(bookingDetails.ArrTime)
                  : ''
              }`}
            </span>
          </div>
        </div>
        <div className="view-booking-details-page__bus-details_address pt-3">
          <Row className="spacing-16">
            <Col className="d-flex flex-column" lg={7} md={6} sm={12}>
              <span>{bookingDetails.TravelsName}</span>
              <span>{getBusAddress(bookingDetails.BpDetails)}</span>
            </Col>
            <Col
              className="d-flex flex-column view-booking-details-page__bus-details_address_ref-container"
              lg={5}
              md={6}
              sm={12}
            >
              <span>Bus Reference Number</span>
              <span>{bookingDetails.TentativeReferenceNo}</span>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
}

BookingDetails.defaultProps = {};

BookingDetails.propTypes = {
  bookingDetails: PropTypes.object.isRequired,
};

export default BookingDetails;
